import { placeStore } from '@/store';
import { useEffect, useState } from 'react';

const { getTabList } = placeStore;

function useGetTabList(resourceType: 0 | 1, tntResourceId: number) {
  const [options, setOptions] = useState<any[]>([]);
  const getList = async (resourceType: 0 | 1, tntResourceId: number) => {
    const result = await getTabList(resourceType, tntResourceId);
    if (!result) {
      return;
    }

    const options = result.map(item => {
      return {
        tab: item.name,
        key: item.tntResourceId,
        resourceType: item.resourceType
      };
    });

    setOptions(options);
  };

  useEffect(() => {
    if (!tntResourceId) {
      return;
    }
    getList(resourceType, tntResourceId);
  }, [tntResourceId, resourceType]);

  return options;
};

export default useGetTabList;
